import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { DefaultErrorModalComponent } from '@monorepo/ui';
import { DISABLE_ERROR_ALERT_HEADER } from '@monorepo/types';

/**
 * This interceptor handles following :
 * 422 [Unprocessable Entity] - Backend validation errors & 500 - unknown server errors
 * AND shows an alert with message from backend
 */
@Injectable()
export class GeneralApiHttpInterceptor implements HttpInterceptor {
  constructor(private modalController: ModalController) {}

  private handleError(err: HttpErrorResponse, disableAlert: boolean): Observable<HttpEvent<any>> {
    if (disableAlert) {
      return throwError(() => err);
    }

    if (err.status === 422) {
      this.showAlert(err.error.errors[0]);
    } else if (err.status === 401 || err.status === 403) {
      this.showAlert('error_modal.UserNotAuthorized');
    } else {
      this.showAlert();
    }

    return throwError(() => err);
  }

  showAlert = async (errorTxt?: string) => {
    const errorModal = await this.modalController.create({
      component: DefaultErrorModalComponent,
      componentProps: {
        errorTxt,
      },
      cssClass: 'm-modal__default-error-modal',
    });
    errorModal.present();
  };

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const disableAlert = req.headers.has(DISABLE_ERROR_ALERT_HEADER);
    const modifiedReq = disableAlert ? req.clone({ headers: req.headers.delete(DISABLE_ERROR_ALERT_HEADER) }) : req;
    return next.handle(modifiedReq).pipe(catchError((x) => this.handleError(x, disableAlert)));
  }
}
